import { Box, Center, Spinner } from '@chakra-ui/react'
import paginate from 'paginate-array'
import {
  createContext,
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef
} from 'react'
import sortObjectsArray from 'sort-objects-array'
import { useImmer } from 'use-immer'

import useParametrizationSimilarProduct from '@hook/parametrization/use-similar-product'

import type {
  ITableGridProps,
  ITableGridContext,
  ITableGridOrder
} from '@base/@types/components/Layout/TableGrid'

import TableGridBody from './Body'
import TableGridHeader from './Header'

const TableGridScrollProductSimilar: FC<ITableGridProps> = ({
  id,
  headers,
  data,
  query = '',
  actions,
  isActions = true,
  loading,
  isPaged = false,
  pagination,
  onSelect,
  entity,
  undoValue,
  dataFooter,
  itsSortable = false,
  itsSortableGroup = false,
  isModal,
  selected,
  updateIsGraphic,
  updatedFinalStorage,
  updateIsModalConfig
}) => {
  const { getData, pageCurrent, total } = useParametrizationSimilarProduct()
  const totalPages = total / 50
  let page = 1
  const scrollRef = useRef(null)
  const [order, updateOrder] = useImmer<ITableGridOrder>({
    column: '',
    sort: null
  })

  const columns = useMemo(() => {
    const arr = []
    for (const row of headers) {
      const columns = row?.columns
      const available = []

      if (columns) {
        for (const column of columns) {
          if (column?.show === true) {
            available.push(column)
          }
        }
      }

      if (!row.id && available.length === 0) {
        continue
      }

      arr.push({
        ...row,
        columns: available
      })
    }

    return arr
  }, [headers])
  const compareValues = (key: any, order = 'asc') => {
    return function innerSort(
      a: { [x: string]: any; hasOwnProperty: (arg0: any) => any },
      b: { [x: string]: any; hasOwnProperty: (arg0: any) => any }
    ) {
      // eslint-disable-next-line no-prototype-builtins
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0
      }
      try {
        const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
        const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]
        if (varA === 0 && varB === '218,28') {
        }
        if (typeof varA === 'number' && typeof varB === 'number') {
          let comparison = 0
          if (varA > varB) {
            comparison = 1
          } else if (varA < varB) {
            comparison = -1
          }
          return order === 'desc' ? comparison * -1 : comparison
        }
        let varAN = 0
        let varBN = 0
        let condition = false
        let conditionA = false
        let conditionB = false
        if (key === 'compra-desejada') {
          if (varA === 'F9.750' || varB === 'F9.750') {
          }
          const varANCD = varA.substring(1, 100)
          const varBNCD = varB.substring(1, 100)

          let varAT =
            typeof varANCD === 'string'
              ? varANCD.includes('.')
                ? varANCD.replaceAll('.', '')
                : varANCD
              : varANCD
          varAT =
            typeof varAT === 'string'
              ? varAT.includes(',')
                ? varAT.replaceAll(',', '.')
                : varAT
              : varAT

          let varBT =
            typeof varBNCD === 'string'
              ? varBNCD.includes('.')
                ? varBNCD.replaceAll('.', '')
                : varBNCD
              : varBNCD
          varBT =
            typeof varBT === 'string'
              ? varBT.includes(',')
                ? varBT.replaceAll(',', '.')
                : varBT
              : varBT
          varBT = Number(varBT)
          varAT = Number(varAT)
          let comparison = 0
          if (varAT > varBT) {
            comparison = 1
          } else if (varAT < varBT) {
            comparison = -1
          }
          return order === 'desc' ? comparison * -1 : comparison
        }
        if (
          typeof varA === 'string' &&
          (varA?.includes(',') || varA?.includes('.')) &&
          !varA.includes(' ')
          // !isNaN(parseFloat(varB)) ||
          // varB?.includes(',') ||
          // varB?.includes('.')
        ) {
          condition = true
          conditionA = true
          // console.log('number')
          // const comparison = 0
          // if (varA === '836.271' || varB === '836.271') {
          //   console.log('achou')
          // }
          // if (isNaN(varA)) {
          //   if (varA.includes('.')) {
          //     const teste = varA.replaceAll('.', '')
          //     console.log('teste', teste)
          //   }
          // }
          let varAT =
            typeof varA === 'string'
              ? varA.includes('.')
                ? varA.replaceAll('.', '')
                : varA
              : varA
          // let varBT =
          //   typeof varB === 'string'
          //     ? varB.includes('.')
          //       ? varB.replaceAll('.', '')
          //       : varB
          //     : varB
          varAT =
            typeof varAT === 'string'
              ? varAT.includes(',')
                ? varAT.replaceAll(',', '.')
                : varAT
              : varAT
          // varBT =
          //   typeof varBT === 'string'
          //     ? varBT.includes(',')
          //       ? varBT.replaceAll(',', '.')
          //       : varBT
          //     : varBT
          varAN = parseFloat(parseFloat(varAT).toFixed(2))
          // const varBN = parseFloat(parseFloat(varBT).toFixed(2))
          // if (varAN > varBN) {
          //   comparison = 1
          // } else if (varAN < varBN) {
          //   comparison = -1
          // }
          // return order === 'desc' ? comparison * -1 : comparison
        } else {
          varAN = varA
        }
        if (
          typeof varB === 'string' &&
          (varB?.includes(',') || varB?.includes('.')) &&
          !varB.includes(' ')
        ) {
          condition = true
          conditionB = true

          //  let varAT =
          //    typeof varA === 'string'
          //      ? varA.includes('.')
          //        ? varA.replaceAll('.', '')
          //        : varA
          //      : varA
          let varBT =
            typeof varB === 'string'
              ? varB.includes('.')
                ? varB.replaceAll('.', '')
                : varB
              : varB
          //  varAT =
          //    typeof varAT === 'string'
          //      ? varAT.includes(',')
          //        ? varAT.replaceAll(',', '.')
          //        : varAT
          //      : varAT
          varBT =
            typeof varBT === 'string'
              ? varBT.includes(',')
                ? varBT.replaceAll(',', '.')
                : varBT
              : varBT
          //  const varAN = parseFloat(parseFloat(varAT).toFixed(2))
          varBN = parseFloat(parseFloat(varBT).toFixed(2))
          // if (varAN > varBN) {
          //   comparison = 1
          // } else if (varAN < varBN) {
          //   comparison = -1
          // }
          // return order === 'desc' ? comparison * -1 : comparison
        } else {
          varBN = varB
        }
        if (varA !== '' && !isNaN(varA) && !conditionA) {
          condition = true
          varAN = Number(varA)
        }
        if (varB !== '' && !isNaN(varB) && !conditionB) {
          condition = true

          varBN = Number(varB)
        }
        if (condition) {
          let comparison = 0

          if (varAN > varBN) {
            comparison = 1
          } else if (varAN < varBN) {
            comparison = -1
          }
          return order === 'desc' ? comparison * -1 : comparison
        }
        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return order === 'desc' ? comparison * -1 : comparison
      } catch (ex) {}
    }
  }

  const rows = useMemo(() => {
    if (query!.length > 0) {
      const toSearch = data

      return paginate(
        order.column !== ''
          ? sortObjectsArray(toSearch, order.column, order.sort)
          : toSearch,
        page,
        isPaged ? 150 : data?.length
      )
    }

    return paginate(
      order.column !== ''
        ? data.sort(compareValues(order.column, order.sort))
        : data,
      page,
      isPaged ? 150 : data?.length
    )
  }, [query, order.column, order.sort, data, page, isPaged])

  const createDiv = (_height: number) => {
    const div = document.createElement('div')

    // div.style.top = '0'
    // div.style.right = '0'
    // div.style.width = '5px'
    // div.style.position = 'absolute'
    // div.style.cursor = 'col-resize'
    // div.style.userSelect = 'none'
    // div.style.height = height + 'px'

    return div
  }

  const getStyleVal = (elm: any, css: any) => {
    return window.getComputedStyle(elm, null).getPropertyValue(css)
  }

  const paddingDiff = useCallback((col: any) => {
    if (getStyleVal(col, 'box-sizing') === 'border-box') {
      return 0
    }

    const padLeft = getStyleVal(col, 'padding-left')
    const padRight = getStyleVal(col, 'padding-right')
    return parseInt(padLeft) + parseInt(padRight)
  }, [])

  const setListeners = useCallback(
    (div: any) => {
      let pageX: any
      let curCol: any
      let curColWidth: any
      let tableWidth: any

      div.addEventListener('mousedown', function (e: any) {
        tableWidth = document.getElementById(`scl-tablegrid-${id}`)!.offsetWidth
        curCol = e.target.parentElement
        pageX = e.pageX

        const padding = paddingDiff(curCol)

        curColWidth = curCol.offsetWidth - padding
      })

      div.addEventListener('mouseover', function (e: any) {
        e.target.style.borderRight = '2px solid var(--chakra-colors-yellow-400)'
      })

      div.addEventListener('mouseout', function (e: any) {
        e.target.style.borderRight = ''
      })

      document.addEventListener('mousemove', function (e) {
        if (curCol) {
          const diffX = e.pageX - pageX

          curCol.style.width = curColWidth + diffX + 'px'
          document.getElementById(`scl-tablegrid-${id}`)!.style.width =
            tableWidth + diffX + 'px'
        }
      })

      document.addEventListener('mouseup', function () {
        curCol = undefined
        pageX = undefined
        curColWidth = undefined
      })
    },
    [id, paddingDiff]
  )

  const resizableGrid = useCallback(
    table => {
      const rows = table.getElementsByTagName('tr')

      table.style.overflow = 'hidden'

      const tableHeight = table.offsetHeight

      for (let n = 0; n < 2; n++) {
        const row = rows[n]
        const cols = row ? row.children : undefined

        for (let i = 0; i < cols.length; i++) {
          const div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }
      }
    },
    [setListeners]
  )

  // const handlePageChange = (page: number) => {
  //   setPage(page + 1)
  // }

  const handleOrder = (id: string) => {
    let sort: 'asc' | 'desc' | null = null

    if (order.column === id) {
      if (order.sort === 'desc') {
        sort = 'asc'
      }
    } else {
      sort = 'desc'
    }

    updateOrder(draft => {
      draft.column = sort === null ? '' : id
      draft.sort = sort
    })
  }

  useEffect(() => {
    const table = document.querySelector(`#scl-tablegrid-${id}`)

    resizableGrid(table)
  }, [id, resizableGrid])

  useEffect(() => {
    const handleScroll = () => {
      const container = scrollRef.current

      if (
        container &&
        container.scrollTop + container.clientHeight >=
          container.scrollHeight - 1 &&
        !loading
      ) {
        if (pageCurrent <= totalPages) {
          page++
          getData(query, pageCurrent + 1, 50, false)
        }
      }
    }

    scrollRef.current?.addEventListener('scroll', handleScroll)
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      scrollRef.current?.removeEventListener('scroll', handleScroll)
    }
  }, [getData, loading, page, query, pageCurrent, totalPages])

  return (
    <TableGridContext.Provider
      value={{
        columns,
        dataFooter: dataFooter || [],
        data: rows,
        page,
        query: query || '',
        handlePageChange: onSelect,
        loading: loading || false,
        order,
        handleOrder,
        itsSortable,
        itsSortableGroup,
        actions,
        entity: entity || '',
        pagination: pagination
      }}
    >
      {' '}
      <Box
        overflow="auto"
        ref={scrollRef}
        h={['20vh', '30vh', '40vh', '50vh', '60vh', '65vh']}
      >
        <table id={`scl-tablegrid-${id}`} className="scl-table-grid">
          <TableGridHeader
            isModal={isModal}
            selected={selected}
            isActions={isActions}
            updateIsModalConfig={updateIsModalConfig}
          />
          <TableGridBody
            key={`tableGridBody-${Number(id) + 1}`}
            undoValue={undoValue}
            updateIsGraphic={updateIsGraphic}
            updatedFinalStorage={updatedFinalStorage}
          />{' '}
        </table>
      </Box>
      {loading && (
        <Center>
          <Spinner />
        </Center>
      )}
    </TableGridContext.Provider>
  )
}

export default TableGridScrollProductSimilar
export const TableGridContext = createContext<ITableGridContext>(
  {} as ITableGridContext
)
